import React, { ChangeEvent } from "react";
import FormDialog from "../../shared/FormDialog";
import { Box, Grid, Link } from "@material-ui/core";
import CustomTextField from "../../shared/CustomTextField";
import ButtonNav from "../../shared/NavBar/ButtonNav";
import useLogin from "./hook/useLogin";
import Hidden from "@material-ui/core/Hidden";

interface IProps {
  open: boolean;
  onClose: () => void;
  onRegister: () => void;
  onRemindPass: () => void;
}

const Login: React.FC<IProps> = ({ open, onClose, onRegister, onRemindPass }: IProps) => {
  const { email, setEmail, password, setPassword, handleSubmit } = useLogin(onClose);
  const handleRegiter = () => {
    onClose();
    onRegister();
  };

  const handleRemindPass = () => {
    onRemindPass();
    onClose();
  };

  return (
    <FormDialog open={open} title={`Logowanie do panelu klienta`} onClose={onClose} showTitle={true} hideActions={true}>
      <Box my={3} style={{ width: "60%", marginLeft: "20%" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CustomTextField
              label={"Email"}
              name={"email"}
              margin={"dense"}
              fullWidth
              value={email}
              onChange={(event: ChangeEvent<HTMLInputElement>) => setEmail(event.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              label={"Hasło"}
              name={"password"}
              margin={"dense"}
              fullWidth
              type={"password"}
              value={password}
              onChange={(event: ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
            />
          </Grid>
          <Hidden mdDown>
            <LoginButton handleRegiter={handleRegiter} handleSubmit={handleSubmit} cell={6} />
          </Hidden>
          <Hidden lgUp>
            <LoginButton handleRegiter={handleRegiter} handleSubmit={handleSubmit} cell={12} />
          </Hidden>

          <Grid item xs={12}>
            <Link component="button" onClick={() => handleRemindPass()}>
              Nie pamiętam hasła
            </Link>
          </Grid>
        </Grid>
      </Box>
    </FormDialog>
  );
};

export default Login;

interface IProps2 {
  handleSubmit: (event: any) => void;
  handleRegiter: () => void;
  cell: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

const LoginButton: React.FC<IProps2> = ({ handleSubmit, handleRegiter, cell }: IProps2) => {
  return (
    <React.Fragment>
      <Grid item xs={cell}>
        <ButtonNav onClick={(event: any) => handleSubmit(event)} fullWidth={true}>
          Zaloguj
        </ButtonNav>
      </Grid>
      <Grid item xs={cell}>
        <ButtonNav onClick={() => handleRegiter()} fullWidth={true}>
          Rejestracja
        </ButtonNav>
      </Grid>
    </React.Fragment>
  );
};
